import { Box, Text } from '@primer/react';
import { darkGradientSx } from '../utils/darkGradient';
import SEO from '../components/SEO';

function Careers() {
  return (
    <Box
      sx={{
        ...darkGradientSx,
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingX: 4,
        overflow: 'hidden',
      }}
    >
      <SEO
        title="Careers at Pegasus UX"
        description="There are currently no open roles at Pegasus UX. Check back later for career opportunities at our enterprise UX design agency."
        path="/careers"
        noindex
      />
      <Box sx={{ maxWidth: '640px', textAlign: 'center' }}>
        <Text
          as="h1"
          sx={{
            margin: 0,
            marginBottom: 3,
            fontFamily: "'Fraunces', serif",
            fontWeight: 300,
            fontSize: ['2rem', '2.5rem', '3rem'],
            color: '#f5f1ea',
          }}
        >
          No open roles right now
        </Text>
        <Text as="p" sx={{ margin: 0, fontSize: 2, lineHeight: 1.7, color: 'rgba(255, 255, 255, 0.55)' }}>
          There are currently no job opportunities available. Please check back later.
        </Text>
      </Box>
    </Box>
  );
}

export default Careers;
